












import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderProductPrepare extends Vue {
  private orderListTypes = orderListTypes.PRODUCT_PREPARE;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
